import * as React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material';
import AssociationBox from './AssociationBox';
import {useGodFather} from './hooks/useGodFather';
import {useState} from 'react';
import {ENTOURAGE, DIGITAL_SPONSOR} from './constant';
import {useDarkMode} from '../darkMode/hook/useDarkMode';
import {useUserInfo} from '../userInfo/hooks/useUserInfo';

const AssociateBody = ({unlinkAccount}) => {
  const {godFathers} = useGodFather();
  const [userChecked, setUserChecked] = useState('');
  const {mode} = useDarkMode();
  const {switchMode} = useUserInfo();

  return (
    godFathers.length > 0 && (
      <Box
        sx={{
          backgroundColor: mode.settings.cardBackgroundColor,
          borderRadius: 1,
          padding: '20px',
        }}>
        <Stack>
          <br />
          {godFathers.findIndex(obj => obj['type'] === ENTOURAGE) !== -1 && (
            <Typography variant={'subtitle2'} color={mode.settings.textColor4}>
              Entourage
            </Typography>
          )}
          <Stack
            direction={'row'}
            justifyContent={'space-between'}
            flexWrap={'wrap'}>
            {godFathers.map(
              (godFathers, index) =>
                godFathers.type === ENTOURAGE && (
                  <AssociationBox
                    mail={godFathers.email}
                    name={`${godFathers.firstname} ${godFathers.lastname}`}
                    index={`${index}-s`}
                    userChecked={userChecked}
                    setUserChecked={setUserChecked}
                  />
                ),
            )}
          </Stack>
          <br />
          {!switchMode && (
            <>
              {godFathers.findIndex(obj => obj['type'] === DIGITAL_SPONSOR) !==
                -1 && (
                <Typography
                  variant={'subtitle2'}
                  color={mode.settings.textColor4}>
                  Parrain
                </Typography>
              )}
              <Stack
                direction={'row'}
                justifyContent={'space-between'}
                flexWrap={'wrap'}>
                {godFathers.map(
                  (godFather, index) =>
                    godFather.type === DIGITAL_SPONSOR && (
                      <AssociationBox
                        mail={godFather.email}
                        name={`${godFather.firstname} ${godFather.lastname}`}
                        index={`${index}-g`}
                        userChecked={userChecked}
                        setUserChecked={setUserChecked}
                      />
                    ),
                )}
              </Stack>
            </>
          )}
          <br />
          {godFathers.length > 0 && (
            <Stack alignItems={'center'}>
              <Button
                className="btnDissociate"
                onClick={() => unlinkAccount(userChecked)}
                style={{
                  width: {xs: '275px', md: '360px', lg: '360px'},
                  paddingTop: {xs: '10px !important'},
                }}>
                <img
                  src={'/assets/icon/repeat.png'}
                  alt={'Dissocier un compte'}
                  style={{marginRight: '10px'}}
                />
                <Typography variant={'subtitle3'} component="span">
                  Dissocier la personne selectionnée
                </Typography>
              </Button>
            </Stack>
          )}
        </Stack>
      </Box>
    )
  );
};

export default AssociateBody;
